import { observable } from "mobx";
import { Type } from "class-transformer";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ShutdownIntervalResponse {
  /**
   * Trading place is closed from this date and time.
   */
  @observable
  @Type(() => Date)
  from!: Date;

  /**
   * Trading place is closed to this date and time.
   */
  @observable
  @Type(() => Date)
  to?: Date;
}
